window.addEventListener('pageshow', function (event) {
  $('.pagetransition').addClass('init-transition-pageshow');
  $('.transition-contain').addClass('init-transition-body-pageshow');
    },
false);


document.addEventListener("DOMContentLoaded", function() {

// Page Animation

$( "body" ).on( "click", "a", function(e) {
  var url = $(this).attr("href"); 
  var target = $(this).attr("target")
  e.preventDefault();
  if($(this).attr("data-linkout") != 'false') {
  if(target != "_blank" && url.includes("#") == false && url.includes("mailto") == false) {
    var currentscrollpos = $(window).scrollTop();
    if($(this).hasClass("menu-drawer__menu-item")) {
      $('.transition-contain').addClass('mobile-link-nav');
    }
    $('.pagetransition').removeClass('init-transition-pageshow').addClass('init-transition');
    $('.transition-contain').removeClass('init-transition-body-pageshow').addClass('init-transition-body');
    $('.main-transition').animate({scrollTop: '+=' + currentscrollpos + 'px'}, 1);
  }
  else if (target == "_blank") {
    window.open(url, '_blank');
  }
  setTimeout(function() {
    if(target != "_blank") { 
    window.location = url;
    }
  }, 750);
}
});


//Fade in Sections

const fadein = document.querySelectorAll(".shopify-section");

let fadeinObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("fade-in");
    }
  });
});

fadein.forEach((element) => {
  fadeinObserver.observe(element);
});


const transformUp = document.querySelectorAll(".transform-in");

let transformUpObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add("transformup");
    }
  });
});

transformUp.forEach((element) => {
  transformUpObserver.observe(element);
});


//Animate Images

const animateimages = document.querySelectorAll("img");

let imageObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.intersectionRatio > 0) {
      entry.target.classList.add("load-img");
    }
  });
});

animateimages.forEach((element) => {
  imageObserver.observe(element);
});


//Change Header When Intersecting Footer

const footer = $("sticky-header");
const mainfooter = $(".section-header");
//const afterfooter = $(".after-footer-graphic");

$(window).scroll(function () {
if(!$('.pagetransition').hasClass("init-transition")) {
  if (
    window.innerHeight + window.pageYOffset + 20 >=
    document.body.offsetHeight
  ) {
    footer.addClass("at-footer");
    mainfooter.addClass("at-footer-main");
    //afterfooter.addClass("fixedgraphic");
  } else if (footer.hasClass("at-footer")) {
    footer.removeClass("at-footer");
    mainfooter.removeClass("at-footer-main");
    //afterfooter.removeClass("fixedgraphic");
  }

}
});


function sizeActSecondLogo() {
  let secondLogoHeight = $('.footer-bottom-logo svg').height();
  $('.footer-top svg').height(secondLogoHeight);
}

$(document).ready(function() {
  sizeActSecondLogo();
});

window.addEventListener('resize', function(event) {
  sizeActSecondLogo();
}, true);

});
